import moment from 'moment';
import { buildStatus } from './statuses';
import { cdnGetFilesApiGroundTechnician, cdnGetFilesApiAdmin } from '../../app/conf';

export const buildTickets = (tickets, type) => (tickets || []).map((ticket) => buildTicket(ticket, type));

export const buildTicket = (ticket, type) => ({
    ...ticket,
    taskId: ('00000000' + ticket.taskId).slice(-8),
    displayDate: buildDisplayDate(ticket.created.date),
    status: buildStatus(ticket.status, type),
    ...buildProperties(ticket.properties)
});

const buildProperties = properties => {
    if (properties) {
        let parsedProperties = {};
        properties.forEach(property => {
            if (property.id === 'creditId') {
                parsedProperties.creditID = property.value;
            }

            if (property.id.includes('clientId')) {
                parsedProperties.account = {
                    ...parsedProperties.account,
                    [buildObjectKey(property.id, 'client')]: property.value
                };
            }

            if (property.id.includes('isCreditOperation')) {
                parsedProperties.isCreditOperation = property.value;
            }

            if (property.id.includes('vehicle')) {
                const keyName = buildObjectKey(property.id, 'vehicle');
                let value = property.value;
                if (keyName === "verification") {
                    try {
                        value = JSON.parse(property.value);
                    } catch (error) {
                        console.log(error);
                    }
                }

                if (keyName === 'image') {
                    try {
                        const path = JSON.parse(property.value);
                        value = cdnGetFilesApiAdmin(path[0]);

                    } catch (error) {
                        console.warn(error);
                    }
                }

                parsedProperties.vehicle = {
                    ...parsedProperties.vehicle,
                    [keyName]: value
                };
            }

            if (property.id.includes('account')) {
                parsedProperties.account = {
                    ...parsedProperties.account,
                    [buildObjectKey(property.id, 'account')]: property.value
                };
            }

            if (property.id.includes('schedule')) {
                parsedProperties.schedule = {
                    ...parsedProperties.schedule,
                    [buildObjectKey(property.id, 'schedule')]: property.value
                };
            }

            if (property.id.includes('assignedData')) {
                parsedProperties.assigned_data = {
                    ...parsedProperties.assigned_data,
                    [buildObjectKey(property.id, 'assignedData')]: property.value
                };
            }

            if (property.id === "gpsInstallation") {
                parsedProperties.gps = property.value;
            }

            if (property.id === "reportsVehicleInstallation") {
                parsedProperties.vehicle = {
                    ...parsedProperties.vehicle,
                    observation: property.value
                }
            }

            if (property.id === "placeVehicleInstallation") {
                try {
                    parsedProperties.vehicle = {
                        ...parsedProperties.vehicle,
                        placeVehicleInstallation: buildFiles(JSON.parse(property.value))
                    }
                } catch (error) {
                    console.warn(error);
                }
            }

            if (property.id === "pointsVehicleInstallation") {
                try {
                    parsedProperties.vehicle = {
                        ...parsedProperties.vehicle,
                        pointsVehicleInstallation: buildFiles(JSON.parse(property.value))
                    }
                } catch (error) {
                    console.log(error);
                }
            }

            if (property.id === "installerSign") {
                try {
                    const value = JSON.parse(property.value);

                    parsedProperties.vehicle = {
                        ...parsedProperties.vehicle,
                        ...value
                    }
                } catch (error) {
                    console.warn(error);
                }
            }

            if (["ProblemDescription", "CauseDescription"].includes(property.id)) {
                parsedProperties.problem = property.value;
            }

            if (["CommentUninstallation", "installerProblem"].includes(property.id)) {
                parsedProperties.observation = property.value;
            }

            if (property.id === "GpsInformation") {
                parsedProperties.vehicle = {
                    ...parsedProperties.vehicle,
                    [buildObjectKey(property.id, 'Information')]: property.value
                }
            }

            if (property.id.includes("Maintenance")) {
                parsedProperties.maintenance = {
                    ...parsedProperties.maintenance,
                    [buildObjectKey(property.id, 'Maintenance')]: property.value
                }
            }

            if (property.id === 'nonInstallationReasonId') {
                parsedProperties.nonInstallationReason = {
                    ...parsedProperties.nonInstallationReason,
                    id: property.value
                };
            }

            if (property.id === 'nonInstallationReasonLabel') {
                parsedProperties.nonInstallationReason = {
                    ...parsedProperties.nonInstallationReason,
                    label: property.value
                };
            }

            if (property.id === 'dealerId') {
                parsedProperties.dealer = {
                    ...parsedProperties.dealer,
                    identifier: property.value
                };
            }

            if (property.id === 'dealerName') {
                parsedProperties.dealer = {
                    ...parsedProperties.dealer,
                    name: property.value
                };
            }

            if (property.id === 'scheduleSendReminder') {
                parsedProperties.scheduleSendReminder = property.value === true || property.value === 'true';
            }

        });

        return parsedProperties;
    } else {
        return {};
    }
};

const buildFiles = (files) => {
    if (files && Array.isArray(files)) {
        return files.map(({ url: fileName }) => {
            const url = cdnGetFilesApiGroundTechnician(fileName);
            return {
                original: url,
                thumbnail: url
            }
        });
    } else {
        return []
    }
}

const buildObjectKey = (value, from = '', to = '') => {
    const name = value.replace(from, to);
    return firstCharToLowercase(name);
};

const firstCharToLowercase = value => value.charAt(0).toLowerCase() + value.slice(1);

const buildDisplayDate = date =>
    moment().format('DD/MM/YYYY') === moment(date).format('DD/MM/YYYY')
        ? moment(date).format('HH:mm')
        : moment(date).format('YYYY-MM-DD');

export const prepareDataToSend = (ticket) => {

    let data = {
        subject: ticket.subject,
        credit_id: ticket.creditID,
        area: ticket.project._id,
        isCreditOperation: ticket.isCreditOperation,
        plan_id: ticket.plan_id,
        vehicle: {
            type: ticket.vehicle.type,
            brand: ticket.vehicle.brand,
            model: ticket.vehicle.model,
            plate: ticket.vehicle.plate,
            chassis: ticket.vehicle.chassis,
            locking: ticket.vehicle.locking,
            gps: ticket.vehicle.gps,
            color: ticket.vehicle.color,
            year: ticket.vehicle.year,
        },
        account: {
            identifier: ticket.account.id,
            name: ticket.account.name,
            last_name: ticket.account.lastName
        },
        schedule: {
            suggested_date: new Date(ticket.schedule.suggestedAppointment).getTime(),
            latitude: ticket.schedule.latitude,
            longitude: ticket.schedule.longitude,
            address: ticket.schedule.address,
            availability: ticket.schedule.availability
        },
        status: ticket.status._id,
    };

    if (ticket._id) {
        data._id = ticket._id;
    }

    if (ticket.schedule.agencyId) {
        data.agency = {
            identifier: ticket.schedule.agencyId,
            name: ticket.schedule.agencyName,
            city: ticket.schedule.agencyCity
        }
    }

    if (ticket.dealer && ticket.dealer.identifier) {
        data.dealer = {
            identifier: ticket.dealer.identifier,
            name: ticket.dealer.name
        };
    }

    if (ticket.vehicle.gps) {
        data.vehicle.gps = ticket.vehicle.gps;
    }

    if (ticket.vehicle.odometer) {
        data.vehicle.odometer = ticket.vehicle.odometer;
    }

    if (ticket.vehicle && ticket.vehicle.identifier) {
        data.vehicle.identifier = ticket.vehicle.identifier;
    }

    if (ticket.problem) {
        data.problem = ticket.problem;
    }

    if (ticket.assigned_data && ticket.assigned_data.id !== ticket.assigned_data.old_assigned) {
        data = {
            ...data,
            assigned: ticket.assigned_data.id,
            assigned_data: {
                identifier: ticket.assigned_data.id,
                name: ticket.assigned_data.name
            }
        };
    }

    if (ticket.schedule && String(ticket.schedule.contactId).length && String(ticket.schedule.contactName).length) {
        data.schedule = {
            ...data.schedule,
            contact: {
                identifier: ticket.schedule.contactId,
                name: ticket.schedule.contactName
            }
        };


        if (String(ticket.schedule.phone).length) {
            data.schedule = {
                ...data.schedule,
                phone: ticket.schedule.phone
            };
        }
    }

    if (ticket.status.name.toLowerCase() === 'scheduled' || (ticket.status.old_status && ticket.status.old_status.toLowerCase() === 'scheduled')) {
        data.installation_date = new Date(ticket.schedule.installationDate).getTime();
    }

    if (ticket.vehicle.image && String(ticket.vehicle.image).length) {
        data.vehicle.image = JSON.stringify([ticket.vehicle.image]);
    }

    if(ticket?.vehicle?.fuel) {
        data.vehicle.fuel = ticket.vehicle.fuel.toLowerCase()
    }

    if (ticket.nonInstallationReason && ticket.nonInstallationReason.id) {
        data.non_installation_reason = {
            id: ticket.nonInstallationReason.id,
            label: ticket.nonInstallationReason.label
        };
    }

    if (ticket.scheduleSendReminder) {
        data.schedule = {
            ...data.schedule,
            send_reminder: ticket.scheduleSendReminder
        };
    }

    return data;
}